import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-blue-50 to-blue-100 border-t border-blue-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-md">
                <span className="text-2xl font-black text-white">R</span>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-black bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">
                  Rummy Games
                </span>
                <span className="text-xs text-gray-600">Premium Gaming</span>
              </div>
            </Link>
            <p className="text-sm text-gray-600 leading-relaxed">
              India's premier rummy gaming platform with 77+ premium games. Experience the ultimate gaming collection with instant withdrawals and massive bonuses.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 rounded-lg bg-blue-100 hover:bg-blue-200 flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-blue-100 hover:bg-blue-200 flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-blue-100 hover:bg-blue-200 flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-blue-100 hover:bg-blue-200 flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-blue-600 font-black text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  All Games
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Game Categories */}
          <div>
            <h3 className="text-blue-600 font-black text-lg mb-6">Game Categories</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Rummy Games
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Casino Games
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Slot Games
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Card Games
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Poker Games
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-blue-600 font-black text-lg mb-6">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Responsible Gaming
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-300 text-sm font-semibold">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-blue-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm">
              © 2026 Rummy Games. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <span>🔒 Secure Gaming</span>
              <span>✓ RNG Certified</span>
              <span>⚡ Instant Withdrawals</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
